import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styles from "./ClientMessagesList.module.css";
export function getStaffUnreadCount(thread) {
    if (thread.lastMessageByRole === "Staff")
        return 0;
    return thread.unreadCount ?? 0;
}
export function getQuoteJobUnreadCount(thread) {
    if (thread.lastMessageByRole === "Staff")
        return 0;
    if (thread.lastMessage?.senderType?.toLowerCase() === "staff")
        return 0;
    return thread.unreadCount ?? 0;
}
export const ClientMessagesList = ({ threads, selectedContactId, onSelectContact, loading = false, emptyMessage = "No contacts found.", }) => {
    if (loading) {
        return (_jsx("div", { className: styles.loading, children: "Loading conversations\u2026" }));
    }
    if (threads.length === 0) {
        return (_jsx("div", { className: styles.listEmpty, children: emptyMessage }));
    }
    return (_jsx(_Fragment, { children: threads.map((thread) => {
            const displayName = thread.contactName || "Unknown";
            const initial = displayName.charAt(0).toUpperCase();
            const isActive = thread.contactId === selectedContactId;
            const effectiveUnread = getStaffUnreadCount(thread);
            return (_jsxs("div", { role: "button", tabIndex: 0, className: `${styles.contactItem} ${isActive ? styles.contactItemActive : ""}`, onClick: () => thread.contactId && onSelectContact(thread.contactId), onKeyDown: (e) => {
                    if ((e.key === "Enter" || e.key === " ") && thread.contactId) {
                        e.preventDefault();
                        onSelectContact(thread.contactId);
                    }
                }, children: [_jsx("div", { className: styles.contactAvatar, children: initial }), _jsx("div", { className: styles.contactInfo, children: _jsxs("div", { className: styles.contactNameRow, children: [_jsx("span", { className: styles.contactName, children: displayName }), effectiveUnread > 0 && (_jsx("span", { className: styles.unreadBadge, children: effectiveUnread > 99 ? "99+" : effectiveUnread }))] }) })] }, thread.id));
        }) }));
};
